export default {
	data() {
		return {
			safetyForms: [],
			companyForms: [],
			formsPage: 1,
			formsNumPages: 0
		}
	},
	computed: {
		mutatedCompanyForms() {
			let vm = this
			return this.companyForms.map(form => {

				form.createdAtLocal = vm.formatDateTimeToLocal(form.created_at)

				form.userName = form.UpdatedBy.first_name+" "+form.UpdatedBy.last_name

				form.formDescription = form.FormChildTemplate.FormTemplate.title + " / " + form.FormChildTemplate.description

				form.description = ""
				form.serialNum = ""

				if ("Equipment" in form && form.Equipment) {
					form.description = form.Equipment.description
					form.serialNum = form.Equipment.serial_num
				}

				form.jobNum = {}
				if (form.Job) {
					form.jobNum = {
						text: "Project #"+form.Job.job_num,
						link: "/project/"+form.Job.slug+"/dashboard"
					}
				}
				else if (form.Service) {
					form.jobNum = {
						text: "Service #"+form.Service.job_num,
						link: "/service/"+form.Service.slug+"/dashboard"
					}
				}

				return form
			})
		}
	},
	methods: {
		companyFormFields(includeEquipmentDescription) {
			let fields = [
				{label: "Created At",key: "createdAtLocal"},
				{label: "Project/Service",key: "jobNum",type:'link'}
			]

			if (includeEquipmentDescription) {
				fields = [...fields,...[
					{label: "Equipment Description",key:"description"},
					{label: "Serial #",key: 'serialNum'}
				]]
			}

			return [...fields,...[
				{label: "Form Description",key: "formDescription"},
				{label: "Submitted By",key: "userName"}
			]]
		},
		fetchEquipmentForms(spinner,equipment_id) {
			let vm = this

			return new Promise((resolve,reject) => {

				let vm = this

				if (spinner)
					this.spinner(true)

				let params = {
					include: [
						{model: "User", fields: ["id","slug","first_name","last_name"]},
						{
							model:"FormChildTemplate",
							fields:["id","slug",'description'],
							include:[
								{
									model:"FormTemplate",
									fields: ["id", "slug", "title"]
								}
							]
						},
						{
							model: "Job",
							fields: ["id","slug","job_num","job_name"]
						},
						{
							model: "Service",
							fields: ["id","slug","job_num","job_name"]
						}
					],
					fields: ["id","slug","expiry","job_id","service_id","is_deactivated","child_template_id","equipment_id","created_at","updated_by","UpdatedBy","created_by"],
					page: this.formsPage
				}

				if (equipment_id) {
					params.filters = [["equipment_id",equipment_id]]
				}
				else {
					params.filters = [["equipment_id >",0]]
					params.include.push({model:"Equipment",fields:["id","slug","description","serial_num"]})
				}

				this.getJSON("CompanyForm/get",params).then(response => {
					
					if (spinner)
						vm.spinner(false)

					if (response.success) {
						if ("companyForms" in vm)
							vm.companyForms = response.data

						if ("formsNumPages" in vm)
							vm.formsNumPages = response.meta.num_pages
					}

					resolve(response)
				})

			})
		}
	}
}